function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-translate';
import { Button, Glyphicon } from 'react-bootstrap';
import debounce from '../utils/debounce';
import SearchSource from '../components/SearchSource';
import { ensureArticleModuleConfig } from '../hocs/ensureArticleModuleConfig';
import './Search.scss';
import LoadingIndicator from '../components/LoadingIndicator';

var mapStateToProps = function mapStateToProps(state) {
  return {
    searchSources: state.searchSources
  };
}; // TODO Make search box oblivious of current search source
// OR make it possible to select search source
// OR make it possible to have multiple search sources


export var Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.onQueryChange = debounce(function (query) {
      if (!query) {
        _this.setState({
          query: '',
          visible: false
        });
      } else {
        _this.setState({
          query: query,
          searchLoading: true,
          visible: true
        });
      }
    }, 500);
    _this.state = {
      query: '',
      searchLoading: false,
      selectedSource: undefined,
      visible: false
    };
    return _this;
  }

  Search.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.checkLoading(nextProps);
    this.checkSelectedSources(nextProps);
  };

  Search.prototype.checkLoading = function checkLoading(props) {
    this.setState({
      searchLoading: Object.keys(props.searchSources).some(function (key) {
        return props.searchSources[key].loading === true;
      })
    });
  };

  Search.prototype.checkSelectedSources = function checkSelectedSources(props) {
    var source = Object.keys(props.searchSources).find(function (key) {
      return props.searchSources[key].selected === true;
    });
    this.setState({
      selectedSource: source
    });
  };

  Search.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        t = _props.t,
        _onResultSelected = _props.onResultSelected,
        sources = _props.sources,
        placeholder = _props.placeholder,
        clearButtonIcon = _props.clearButtonIcon,
        searchResult = _props.searchResult;
    return React.createElement('div', {
      className: ['search--container'].join(' ')
    }, React.createElement('div', {
      className: 'search--inputWrap'
    }, React.createElement('input', {
      type: 'text',
      className: 'form-control',
      placeholder: placeholder || t('Search'),
      ref: 'queryField',
      required: true,
      onChange: function onChange(e) {
        return _this2.onQueryChange(e.target.value);
      },
      onFocus: function onFocus() {
        return _this2.setState({
          visible: true
        });
      }
    }), React.createElement(Button, {
      bsStyle: 'link',
      title: t('Clear'),
      onClick: function onClick() {
        _this2.refs.queryField.value = '';

        _this2.setState({
          query: '',
          visible: false
        });
      }
    }, clearButtonIcon || React.createElement(Glyphicon, {
      glyph: 'remove'
    }))), this.state.searchLoading && React.createElement('div', {
      className: 'search--loadingElem'
    }, React.createElement(LoadingIndicator, null)), React.createElement('div', {
      className: ['search--searchSources', !this.state.visible ? 'search--hideSources' : ''].join(' ')
    }, sources.map(function (source) {
      return React.createElement(SearchSource, {
        source: source,
        visible: !_this2.state.selectedSource || _this2.state.selectedSource === source.dataIndex,
        onResultSelected: function onResultSelected(result) {
          _onResultSelected(result, source);

          _this2.refs.queryField.value = '';

          _this2.setState({
            visible: false,
            query: ''
          });
        },
        key: source.dataIndex,
        title: source.text,
        query: _this2.state.query,
        multireducerKey: source.dataIndex,
        searchResult: searchResult
      });
    })));
  };

  return Search;
}(React.Component);
Search.propTypes = process.env.NODE_ENV !== "production" ? {
  t: PropTypes.func.isRequired,
  onResultSelected: PropTypes.func.isRequired,
  sources: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  clearButtonIcon: PropTypes.object,
  searchResult: PropTypes.object
} : {};
export default translate('Search')(connect(mapStateToProps)(ensureArticleModuleConfig(Search)));